// cspell: ignore ponyfill
// TODO: Upgrade to `web-streams-polyfill@4.0.0-beta.2` once released.
// `web-streams-polyfill@4.0.0-beta.1` changed the default export to ponyfill,
// But it forgot to include `type` export so it's unusable.
// See https://github.com/MattiasBuelens/web-streams-polyfill/pull/107
export * from 'web-streams-polyfill';
export let AbortController;
({ AbortController } = globalThis);
//# sourceMappingURL=detect.polyfill.js.map